import { IconButton, Tooltip } from '@mui/material';
import { Delete } from '@mui/icons-material';

export const DeleteExerciseButton = (props: { setShowDeleteModal: (show: boolean) => void }) => {
  const { setShowDeleteModal } = props;

  return (
    <Tooltip title="Delete Exercise">
      <IconButton
        onClick={(e) => {
          e.stopPropagation();
          setShowDeleteModal(true);
        }}
      >
        <Delete />
      </IconButton>
    </Tooltip>
  );
};
